import { Component, ViewChild, OnInit, ElementRef, AfterViewInit } from '@angular/core';

@Component({
  selector: 'map',
  templateUrl: 'map.html',
  styles: [

  ]
})

export class MapComponent implements AfterViewInit {
  @ViewChild("gmap") gmapElement: ElementRef;
  map: google.maps.Map;
  marker: google.maps.Marker;
  constructor() { }

  ngAfterViewInit(): void {
    let target = new google.maps.LatLng(47.4758378, 9.7274025);
    let mapProp = {
      center: target,
      zoom: 17,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);
    this.marker = new google.maps.Marker({ position: target, map: this.map });
  }
}
